module.exports = __webpack_public_path__ + "img/portfolio.6889f102.png";